import { useTranslations } from 'next-intl';
import {
  MyEquipmentInfoToolTip,
  useBreakpoint
} from '@cat-ecom/pcc-components';
import { CatHeading } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const AddEquipmentHeading = ({
  title,
  classname
}: {
  title?: string;
  classname?: string;
}) => {
  const t = useTranslations();
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  return (
    <div
      slot="header"
      className={`d-flex align-items-center gap-1 ${classname}`}
    >
      <CatHeading variant={isDesktop ? 'title' : 'title-sm'}>
        {title}
      </CatHeading>
      <MyEquipmentInfoToolTip
        position="bottom"
        ariaLabel={`${t('PLEASE_NOTE')} ${t('MEQ_SUPPORTED_EQUIP1')}`}
        label={t('MEQ_SUPPORTED_EQUIP1')}
        isInteractive={!isDesktop}
      >
        <span className="fw-bold me-1">{t('PLEASE_NOTE')}</span>
      </MyEquipmentInfoToolTip>
    </div>
  );
};

export default AddEquipmentHeading;
